export const questionTemplateToRecipientMap: { [key: string]: string } = {
  "65ce99cab77b9d31123c8fe8": "Девушка(рус)",
  "65dda647dc778d94d0928969": "Девушка(рус)",
  "65ec32098563e6c8d7d19b47": "Девушка(анг)",
  "65ec32bffc68f8ec35c47182": "Парень(рус)",
  "65fb40c5b63f0df17f6ce6ae": "Мама(рус)",
  "65fb7789f6d6c9118d3caead": "Сестра(рус)",
  "660e01f1fd89fc1e241dd19d": "Себе(рус)",
  "660e02b2ce933929f288c10c": "Парень(рус)",
  "660e255e4d408cc2c1155322": "Гей(рус)",
  "66137cae18ab6072f1cea1df": "Парень(анг)",
  "6614f4093cfbb2d01710d3fe": "Девушка(каз)",
  "66163e630f78aa6b9f522b09": "Девушка(каз)",
  "661970fd80f5c5317e0882c3": "Подруга(рус)",
  "6624bbb268a76a62345780d0": "Друг(рус)",
  "6633b5a9d756354cd72cdce3": "Папа(рус)",
  "663c82d1dbc2b382da139155": "Дочь(рус)",
  "6646846c04d73737d26e56bd": "Мама(каз)",
  "664684ee02d2bee370557777": "Родители(рус)",
  "665afb73525a17e9d582152a": "Папа(каз)",
  "665afbc4b5d1639649ba7383": "Родители(каз)",
  "6666a29a5fb6c1ec70816c19": "Руководитель(рус)",
  "66796202bec27bef793297e8": "Сын(рус)",
};

export const DEFAULT_PROMPT =
  "Исправь грамматические, орфографические и пунктуационные ошибки в следующем тексте и верни только исправленный текст. Соблюдай данные правила: 1. Не изменяй структуру текста и не переставляй предложения. 2. Не добавляй ничего от себя, включая дополнительные комментарии или слова. 3. Если текст состоит из одного слова или очень короткого фрагмента, просто исправь его без дополнительных комментариев. Текст для исправления: ";
